import { normalizeBarcode } from "../food-sources/open-food-facts/mapper";

export interface BarcodeScanOptions {
  signal?: AbortSignal;
  timeoutMs?: number;
}

export interface BarcodeScanner {
  isSupported(): Promise<boolean>;
  scan(video: HTMLVideoElement, options?: BarcodeScanOptions): Promise<string>;
}

export class BarcodeScanError extends Error {
  constructor(
    message: string,
    readonly kind: "unsupported" | "permission-denied" | "not-found" | "camera-error" | "invalid-barcode",
  ) {
    super(message);
    this.name = "BarcodeScanError";
  }
}

export function manualBarcode(input: string): string {
  const barcode = normalizeBarcode(input);
  if (!barcode) throw new BarcodeScanError("Enter a barcode containing 6 to 14 digits", "invalid-barcode");
  return barcode;
}
